import { useFetchById } from '../reactQuery';
import { PRODUCT_BANK_API } from '../../../constant/api_url';
import { ProductBank } from '../../../types/productBanks.types';

export const useBankProductById = (id: string | number) =>
  useFetchById<ProductBank>(`${PRODUCT_BANK_API}/${id}`, id);
